import { render } from "./FbaLabelView.vue?vue&type=template&id=0afe1113&scoped=true"
import script from "./FbaLabelView.vue?vue&type=script&lang=js"
export * from "./FbaLabelView.vue?vue&type=script&lang=js"

import "./FbaLabelView.vue?vue&type=style&index=0&id=0afe1113&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afe1113"]])

export default __exports__